import React from 'react';
import styled from 'styled-components';

import type { IDropdownItem } from '@/components/common/dropdown';

import { CrossIcon } from '@/assets/icons';
import { SIDEBAR_DELAY, Z_INDEX_BOTTOM_DRAWER } from '@/config/variables';
import { Dropdown } from '@/components/common/dropdown';
import { media } from '@/styles/theme';

interface IDrawer {
  children?: React.ReactNode;
  show: boolean;
  handleClose: () => void;
  dropDownMenu?: { onClick: () => void; title: string; hide?: boolean }[];
  hideDropdown?: boolean;
}

const Drawer = ({ children, show, handleClose, dropDownMenu, hideDropdown }: IDrawer): React.ReactElement => {
  const menuElements: React.ReactElement<IDropdownItem>[] =
    dropDownMenu
      ?.filter(item => !item.hide)
      ?.map((item, index) => (
        <Dropdown.Item key={index} onClick={item.onClick}>
          {item.title}
        </Dropdown.Item>
      )) ?? [];

  return (
    <>
      <Background hidden={!show} />
      <Container className={show ? '' : 'collapsed'}>
        <div>
          {!!menuElements.length && !hideDropdown && (
            <DropdownContainer>
              <Dropdown>{menuElements}</Dropdown>
            </DropdownContainer>
          )}
          <CloseModalIcon onClick={handleClose} />
        </div>
        {children}
      </Container>
    </>
  );
};

export { Drawer };

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${Z_INDEX_BOTTOM_DRAWER};
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0.5;
`;

const Container = styled.div`
  position: fixed;
  bottom: 0;
  width: 100vw;
  max-width: 1440px;
  max-height: 70vh;
  height: 100%;
  overflow-y: auto;
  z-index: ${Z_INDEX_BOTTOM_DRAWER};
  padding: 18px 31px 0 31px;

  background-color: #fff;
  border: 1px solid #e6f3fc;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.075);
  border-radius: 20px 20px 0 0;

  transition: height ${SIDEBAR_DELAY}ms, padding-top ${SIDEBAR_DELAY}ms;

  &.collapsed {
    height: 0;
    padding-top: 0;
  }
`;

const CloseModalIcon = styled.div`
  position: absolute;
  top: 20px;
  right: 10px;

  height: 40px;
  width: 40px;

  background-image: url(${CrossIcon});
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
`;

const DropdownContainer = styled.div`
  position: absolute;
  top: 24px;
  right: 48px;

  ${media.laptop} {
    display: none;
  }
`;
